import React from "react";
import Card from "components/card";
import DownloadButton from "components/button/download";
import { displayIcon } from "variables/icons";

const DocumentCard = ({
    documentData,
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200 hover:shadow-md transition-all dark-mode-card">
            <div className="pb-6 p-4">
                <div className="flex items-start justify-between">
                    <div className="flex items-start gap-3">
                        <div className="p-2 rounded bg-emerald-100">
                            {displayIcon("FileText", "w-5 h-5 text-emerald-600")}
                        </div>

                        <div>
                            <p className="font-semibold text-sm title-text">
                                {documentData?.doc_title}
                            </p>

                            <p className="text-xs muted-text">
                                {documentData?.doc_date}
                            </p>
                        </div>
                    </div>

                    <span className="status-indicator normal !border-none bg-slate-50">
                        {documentData?.doc_type_name}
                    </span>
                </div>

                <DownloadButton
                    className="access-button btn-download !h-8 !text-sm w-full mt-3 !text-white bg-emerald-600 hover:bg-emerald-700 focus:ring-emerald-500 dark:bg-emerald-500 dark:hover:bg-emerald-600 dark:focus:ring-emerald-400"
                    title="Preview"
                    type="preview"
                    attachmentData={documentData?.attachment}
                />
            </div>
        </Card>
    );
};

export default DocumentCard;